<template>
  <svg
    :width="width"
    :height="height"
    class="icon-chevron-down"
    :class="[
      `icon-chevron-down--color-${color}`,
      {
        'icon-chevron-down--rotate': isActive,
      },
    ]"
    :viewBox="isSolid ? '0 0 25 13' : '0 0 24 24'"
  >
    <path v-if="isSolid" d="M12.5 13L0.808657 0.25L24.1913 0.25L12.5 13Z" />
    <path
      v-else
      d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
    />
  </svg>
</template>

<script>
  export default {
    name: 'IconChevronDown',
    props: {
      width: {
        type: Number,
        required: false,
        default: 24,
      },
      height: {
        type: Number,
        required: false,
        default: 24,
      },
      color: {
        type: String,
        default: 'white',
        validator: (value) =>
          [
            'white',
            'black',
            'grey',
            'dark-grey',
            'charcoal',
            'blue',
            'green',
            'green-mid',
          ].includes(value),
      },
      isActive: Boolean,
      isSolid: Boolean,
    },
  };
</script>

<style lang="scss" scoped>
  .icon-chevron-down {
    transition: all 300ms ease-in-out;
    transform: rotate(0);
    fill: currentColor;

    &--rotate {
      transition: all 300ms ease-in-out;
      transform: rotate(180deg);
    }

    &--color-white {
      fill: #ffffff;
    }
    &--color-black {
      fill: #000000;
    }
    &--color-grey {
      fill: #a7a9ab;
    }
    &--color-dark-grey {
      fill: var(--itr-grey-mid);
    }
    &--color-charcoal {
      fill: var(--itr-charcoal);
    }
    &--color-blue {
      fill: #17355c;
    }
    &--color-green {
      fill: var(--itr-green);
    }
    &--color-green-mid {
      fill: var(--itr-green-mid);
    }
  }
</style>
